import { ArrowNavigation } from 'components/ArrowNavigation/ArrowNavigation';
import { Button } from 'components/Button/Button';
import { CarouselState } from 'components/Carousel/CarouselState';
import { Hide } from 'components/Hide/Hide';
import { Text } from 'components/Text/Text';
import { colors } from 'theme/theme';

type Props = {
  carouselState: CarouselState;
  fullWidth: boolean;
};

export function SlideshowNavigation({ carouselState, fullWidth }: Props) {
  const {
    currentPage,
    pageCount,
    goToNextPage,
    goToPreviousPage,
    hasPreviousPage,
    hasNextPage,
  } = carouselState;

  if (pageCount <= 1) return null;

  return (
    <>
      <Hide md={fullWidth} lg={fullWidth} xl={fullWidth}>
        <ArrowNavigation
          nextPage={goToNextPage}
          prevPage={goToPreviousPage}
          current={currentPage}
          total={pageCount}
          outset
        />

        <div style={{ display: 'block', textAlign: 'center', marginTop: 24 }}>
          <Text
            color={colors.lightContentGrey}
            lineHeight="0.8"
            fontSize="14px"
            letterSpacing="0.44px"
          >
            {currentPage + 1} of {pageCount}
          </Text>
        </div>
      </Hide>

      {fullWidth && (
        <Hide xs sm>
          <div style={{ display: 'block', textAlign: 'center', marginTop: 24 }}>
            <Button
              type="button"
              onClick={goToPreviousPage}
              disabled={!hasPreviousPage}
              data-qa-id="prev-media"
              variant="tertiary"
            >
              {getText('Previous')}
            </Button>

            <Text
              color={colors.lightContentGrey}
              m="0 10px"
              p="0 10px"
              borderLeft={`1px solid ${colors.elementGrey}`}
              borderRight={`1px solid ${colors.elementGrey}`}
              lineHeight="0.8"
              fontSize="14px"
              letterSpacing="0.44px"
            >
              {currentPage + 1} of {pageCount}
            </Text>

            <Button
              type="button"
              onClick={goToNextPage}
              disabled={!hasNextPage}
              data-qa-id="next-media"
              variant="tertiary"
            >
              {getText('Next')}
            </Button>
          </div>
        </Hide>
      )}
    </>
  );
}
